module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAELSURBVEhL7dOxSwJhHMbxC0QaCnepxd1JcE6XoqZAGlrE/8JFnKSptUmcHdKxJWhqcHLwDxDJJgdraky/z/G+3HEU5Huvi/nAB+99kd+j790FO5UaxmiEqy2kixXa4WoLeYMKPvCICrzmFjMc4xkqu0E8V3g3LrWxaU7MZxMquAtXUebQvugfO+cCGvIUrqJ4K8hDQ5Y404aJjkUlGn6ujTR5gf21Q5RxAG/JoYdv2KJP6F3powQvqWIKW2ItcAoveUCyQF6RReqMEB+sG22P7h6pksEX4gUdtMy1iq7hnCLiw0UD9UQNzFo3vwCn1JEs0HuiHGEC7enpOsQ/SPI4XP2an77sYp+/JAjW+Jx0YHP29WwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-construction-worker/dark/24.png
// module id = 1958
// module chunks = 2